// Environment variable configuration for Vite
// All client-side variables must be prefixed with VITE_

function getEnvVar(key: string): string {
  const value = import.meta.env[key];
  if (value === undefined) {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
}

function getEnvVarOptional(key: string, defaultValue = ""): string {
  return import.meta.env[key] ?? defaultValue;
}

function getEnvBool(key: string, defaultValue = false): boolean {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  return value === "true" || value === "1";
}

export const env = {
  // App environment
  VITE_APP_ENV: getEnvVar("VITE_APP_ENV"),

  // API
  VITE_CORE_API_REST_URL: getEnvVar("VITE_CORE_API_REST_URL"),

  // Firebase
  VITE_FIREBASE_API_KEY: getEnvVar("VITE_FIREBASE_API_KEY"),
  VITE_FIREBASE_AUTH_DOMAIN: getEnvVar("VITE_FIREBASE_AUTH_DOMAIN"),

  // Analytics
  VITE_POSTHOG_HOST: getEnvVar("VITE_POSTHOG_HOST"),
  VITE_POSTHOG_KEY: getEnvVar("VITE_POSTHOG_KEY"),
  VITE_POSTHOG_ENVIRONMENT: getEnvVar("VITE_POSTHOG_ENVIRONMENT"),

  // Sanity CMS
  VITE_SANITY_PROJECT_ID: getEnvVarOptional("VITE_SANITY_PROJECT_ID"),
  VITE_SANITY_DATASET: getEnvVarOptional("VITE_SANITY_DATASET", "production"),
  VITE_SANITY_API_VERSION: getEnvVarOptional(
    "VITE_SANITY_API_VERSION",
    "2025-02-10",
  ),
  VITE_SANITY_STUDIO_URL: getEnvVarOptional(
    "VITE_SANITY_STUDIO_URL",
    "http://localhost:3333",
  ),

  // Sentry
  VITE_SENTRY_DSN: getEnvVarOptional("VITE_SENTRY_DSN"),

  // Staff login
  VITE_STAFF_EMAIL_DOMAIN: getEnvVarOptional(
    "VITE_STAFF_EMAIL_DOMAIN",
    "naud-staff.local",
  ),

  // Help centre (empty until a destination exists — button stays disabled)
  VITE_HELP_CENTRE_URL: getEnvVarOptional("VITE_HELP_CENTRE_URL"),

  // Shared-device linking + PIN login. Off by default so the feature stays dark
  // until it's switched on per environment; when true, touch devices get the
  // device-setup / PIN-login flow (still gated per-nursery by pinLoginEnabled).
  VITE_DEVICE_LINKING_ENABLED: getEnvBool("VITE_DEVICE_LINKING_ENABLED"),

  // People Hub: the People directory, Add Employee, the sidebar link and the
  // "My profile" menu item. Off by default so the old Configure → Staff screens
  // stay live until the hub is complete. The /people/:userId routes stay
  // reachable either way, since the old staff form links to login history.
  VITE_PEOPLE_HUB_ENABLED: getEnvBool("VITE_PEOPLE_HUB_ENABLED"),
};
